const AppConfig = window['AppConfig'] || {};

export function useConfig() {
  return AppConfig;
}
